// Copyright 2024 Sorama B.V.
/* tslint: disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v7.7.6173.30627 (NJsonSchema v5.19.6171.28316) (http://NSwag.org)
// </auto-generated>
//----------------------

export interface LinkProperties {}

export interface LayeredLinkProperties extends LinkProperties {
    layer: number;
}

export interface Point3D {
    x: number;
    y: number;
    z: number;
}

export interface TargetAndSourceRegionLinkProperties extends LayeredLinkProperties {
    targetRegion: FourPointRegion;
    sourceRegion: FourPointRegion;
}

export interface TargetRegionLinkProperties extends LayeredLinkProperties {
    targetRegion: FourPointRegion;
}

export interface DeviceProperties {}

export interface CameraProperties extends DeviceProperties {
    focalX: number;
    focalY: number;
    principalX: number;
    principalY: number;
    alignmentMatrix: number[];
    imageOrientation: WebcamImageOrientation;
}

export interface WebCamDeviceProperties extends CameraProperties {
    cropToWideScreen: boolean;
    sensorOffsetCorrectionX: number;
    sensorOffsetCorrectionY: number;
}

/** DTO object for canvas. */
export interface CanvasDTO {
    /** Id of the Canvas */
    id: string;
    /** Id of the CanvasCollection this Canvas is a part of */
    canvasCollectionId: string;
    /** Size of this Canvas in units relative to its contents
(e.g. not in pixels or meters, but in abstract units
depending on the place where it is actually rendered in a UI
and the relative sizes of its contents) */
    size?: Dimension;
}

export interface Dimension {
    width: number;
    height: number;
}

/** Base class for all MediaObjectLink DTO's */
export interface MediaObjectLinkDTO {
    /** Id of this media object link. */
    id: string;
    /** Id of the LinkedMediaObject that is being linked to */
    mediaObjectId: string;
    /** Time at which this media object link was created. */
    created: Date;
    /** Link properties of this MediaObjectLink */
    properties: LinkProperties;
}

export interface CanvasMediaObjectLinkDTO extends MediaObjectLinkDTO {
    /** Id of the target canvas this link is directed to. */
    targetId: string;
}

export interface FourPointRegion {
    topLeft: Point2D;
    topRight: Point2D;
    bottomLeft: Point2D;
    bottomRight: Point2D;
}

export interface Point2D {
    x: number;
    y: number;
}

/** Poco object for the creation of a new MediaObjectLink */
export interface NewMediaObjectLinkDTO {
    /** Id of the LinkedMediaObject that is being linked to */
    mediaObjectId: string;
    /** Link properties of this MediaObjectLink */
    properties: LinkProperties;
}

export interface UpdateTextBoxDTO {
    /** Text that the text-box contains */
    text?: string;
    /** Size of the font in the text-box in ??? */
    fontSize?: number;
    /** Alignment of the text inside the text-box boundaries */
    textAlignment?: TextAlignments;
    /** The color of the text */
    color?: number;
    /** The color of the text's background */
    background?: number;
}

export enum TextAlignments {
    Left = <any>"left",
    Right = <any>"right",
    Center = <any>"center",
    Justify = <any>"justify",
}

/** Base class for all linked media object types */
export interface LinkedMediaObjectDTO {
    /** Id of this linked media object. */
    id: string;
    /** Time at which this linked media object was created. */
    created: Date;
    /** Type of this media object */
    type: LinkedMediaObjectType;
}

export interface TextBoxDTO extends LinkedMediaObjectDTO {
    /** Text that the text-box contains */
    text: string;
    /** Size of the font in the text-box in ??? */
    fontSize: number;
    /** Alignment of the text inside the text-box boundaries */
    textAlignment: TextAlignments;
    /** The color of the text */
    color: number;
    /** The color of the text's background */
    background: number;
}

export enum LinkedMediaObjectType {
    Snapshot = <any>"Snapshot",
    Image = <any>"Image",
    Video = <any>"Video",
    TextBox = <any>"TextBox",
    File = <any>"File",
}

/** Poco object for the creation of new images stored on the cloud storage */
export interface NewImageDTO {
    /** Name for the image */
    name: string;
    /** Optional description of the image */
    description?: string;
    /** Data of the image */
    data: string;
}

/** Base class for all linked file object types */
export interface LinkedFileObjectDTO extends LinkedMediaObjectDTO {
    /** Preview of this media object. Format of this string is implementation defined. */
    preview?: string;
    /** Mimetype of this media object */
    mimeType?: string;
}

/** Base class for all linked media objects that have two dimensions, like images and videos. */
export interface TwoDimensionalLinkedMediaObjectDTO extends LinkedFileObjectDTO {
    /** Dimension of the two dimensional media object in pixels */
    dimension: Dimension;
}

/** Base class for all linked image linked media objects (with image mime-types). */
export interface ImageMediaObjectDTO extends TwoDimensionalLinkedMediaObjectDTO {}

export interface ImageDTO extends ImageMediaObjectDTO {
    /** User provided name of the image */
    name: string;
    /** Optional user provided description of the image */
    description?: string;
}

/** Poco object for the creation of new videos stored on the cloud storage */
export interface NewVideoDTO {
    /** Name for the image */
    name: string;
    /** Optional description of the image */
    description?: string;
    /** Data of the image */
    data: string;
}

export interface VideoDTO extends TwoDimensionalLinkedMediaObjectDTO {
    /** User provided name of the image */
    name: string;
    /** Optional user provided description of the image */
    description?: string;
    /** Duration of the video in seconds */
    duration: number;
}

/** Poco object for the creation of new text-boxes stored on the cloud storage */
export interface NewTextBoxDTO {
    /** Text that the text-box contains */
    text: string;
    /** Size of the font in the text-box in ??? */
    fontSize: number;
    /** Alignment of the text inside the text-box boundaries */
    textAlignment: TextAlignments;
    /** The color of the text */
    color: number;
    /** The color of the text's background */
    background: number;
}

/** Poco object for the creation of new files stored on the cloud storage */
export interface NewFileDTO {
    /** Name for the file */
    name: string;
    /** Optional description of the file */
    description?: string;
    /** Data of the file */
    data: string;
    /** Mime type of the file */
    mimeType: string;
}

export interface FileDTO extends LinkedFileObjectDTO {
    /** User provided name of the file */
    name: string;
    /** Optional user provided description of the file */
    description?: string;
}

export interface ODataQueryOptions {
    Request?: HttpRequestMessage;
    Context?: ODataQueryContext;
    RawValues?: ODataRawQueryOptions;
    SelectExpand?: SelectExpandQueryOption;
    Apply?: ApplyQueryOption;
    Filter?: FilterQueryOption;
    OrderBy?: OrderByQueryOption;
    Skip?: SkipQueryOption;
    SkipToken?: SkipTokenQueryOption;
    Top?: TopQueryOption;
    Count?: CountQueryOption;
    Validator?: ODataQueryValidator;
    IfMatch?: ETag;
    IfNoneMatch?: ETag;
}

export interface ODataQueryOptionsOfVideoDTO extends ODataQueryOptions {
    IfMatch?: ETagOfVideoDTO;
    IfNoneMatch?: ETagOfVideoDTO;
}

export interface DynamicObject {}

export interface ETag extends DynamicObject {
    Item?: any;
    IsWellFormed: boolean;
    EntityType?: string;
    IsAny: boolean;
    IsIfNoneMatch: boolean;
}

export interface ETagOfVideoDTO extends ETag {}

export interface HttpRequestMessage {
    Version?: Version;
    Content?: HttpContent;
    Method?: HttpMethod;
    RequestUri: string;
    Headers?: HttpRequestHeaders;
    Properties?: { [key: string]: any };
}

export interface Version {
    Major: number;
    Minor: number;
    Build: number;
    Revision: number;
    MajorRevision: number;
    MinorRevision: number;
}

export interface HttpContent {
    Headers?: HttpContentHeaders;
}

export interface HttpContentHeaders {
    Allow?: string[];
    ContentDisposition?: ContentDispositionHeaderValue;
    ContentEncoding?: string[];
    ContentLanguage?: string[];
    ContentLength?: number;
    ContentLocation: string;
    ContentMD5?: string;
    ContentRange?: ContentRangeHeaderValue;
    ContentType?: MediaTypeHeaderValue;
    Expires?: Date;
    LastModified?: Date;
}

export interface ContentDispositionHeaderValue {
    DispositionType?: string;
    Parameters?: NameValueHeaderValue[];
    Name?: string;
    FileName?: string;
    FileNameStar?: string;
    CreationDate?: Date;
    ModificationDate?: Date;
    ReadDate?: Date;
    Size?: number;
}

export interface NameValueHeaderValue {
    Name?: string;
    Value?: string;
}

export interface ContentRangeHeaderValue {
    Unit?: string;
    From?: number;
    To?: number;
    Length?: number;
    HasLength: boolean;
    HasRange: boolean;
}

export interface MediaTypeHeaderValue {
    CharSet?: string;
    Parameters?: NameValueHeaderValue[];
    MediaType?: string;
}

export interface ValueType {}

export interface KeyValuePairOfStringAndIEnumerableOfString extends ValueType {
    Key?: string;
    Value?: string[];
}

export interface HttpMethod {
    Get?: HttpMethod;
    Put?: HttpMethod;
    Post?: HttpMethod;
    Delete?: HttpMethod;
    Head?: HttpMethod;
    Options?: HttpMethod;
    Trace?: HttpMethod;
    Method?: string;
}

export interface HttpRequestHeaders {
    Accept?: MediaTypeWithQualityHeaderValue[];
    AcceptCharset?: StringWithQualityHeaderValue[];
    AcceptEncoding?: StringWithQualityHeaderValue[];
    AcceptLanguage?: StringWithQualityHeaderValue[];
    Authorization?: AuthenticationHeaderValue;
    Expect?: NameValueWithParametersHeaderValue[];
    ExpectContinue?: boolean;
    From?: string;
    Host?: string;
    IfMatch?: EntityTagHeaderValue[];
    IfModifiedSince?: Date;
    IfNoneMatch?: EntityTagHeaderValue[];
    IfRange?: RangeConditionHeaderValue;
    IfUnmodifiedSince?: Date;
    MaxForwards?: number;
    ProxyAuthorization?: AuthenticationHeaderValue;
    Range?: RangeHeaderValue;
    Referrer: string;
    TE?: TransferCodingWithQualityHeaderValue[];
    UserAgent?: ProductInfoHeaderValue[];
    CacheControl?: CacheControlHeaderValue;
    Connection?: string[];
    ConnectionClose?: boolean;
    Date?: Date;
    Pragma?: NameValueHeaderValue[];
    Trailer?: string[];
    TransferEncoding?: TransferCodingHeaderValue[];
    TransferEncodingChunked?: boolean;
    Upgrade?: ProductHeaderValue[];
    Via?: ViaHeaderValue[];
    Warning?: WarningHeaderValue[];
}

export interface MediaTypeWithQualityHeaderValue extends MediaTypeHeaderValue {
    Quality?: number;
}

export interface StringWithQualityHeaderValue {
    Value?: string;
    Quality?: number;
}

export interface AuthenticationHeaderValue {
    Scheme?: string;
    Parameter?: string;
}

export interface NameValueWithParametersHeaderValue extends NameValueHeaderValue {
    Parameters?: NameValueHeaderValue[];
}

export interface EntityTagHeaderValue {
    Tag?: string;
    IsWeak: boolean;
    Any?: EntityTagHeaderValue;
}

export interface RangeConditionHeaderValue {
    Date?: Date;
    EntityTag?: EntityTagHeaderValue;
}

export interface RangeHeaderValue {
    Unit?: string;
    Ranges?: RangeItemHeaderValue[];
}

export interface RangeItemHeaderValue {
    From?: number;
    To?: number;
}

export interface TransferCodingHeaderValue {
    Value?: string;
    Parameters?: NameValueHeaderValue[];
}

export interface TransferCodingWithQualityHeaderValue extends TransferCodingHeaderValue {
    Quality?: number;
}

export interface ProductInfoHeaderValue {
    Product?: ProductHeaderValue;
    Comment?: string;
}

export interface ProductHeaderValue {
    Name?: string;
    Version?: string;
}

export interface CacheControlHeaderValue {
    NoCache: boolean;
    NoCacheHeaders?: string[];
    NoStore: boolean;
    MaxAge?: string;
    SharedMaxAge?: string;
    MaxStale: boolean;
    MaxStaleLimit?: string;
    MinFresh?: string;
    NoTransform: boolean;
    OnlyIfCached: boolean;
    Public: boolean;
    Private: boolean;
    PrivateHeaders?: string[];
    MustRevalidate: boolean;
    ProxyRevalidate: boolean;
    Extensions?: NameValueHeaderValue[];
}

export interface ViaHeaderValue {
    ProtocolName?: string;
    ProtocolVersion?: string;
    ReceivedBy?: string;
    Comment?: string;
}

export interface WarningHeaderValue {
    Code: number;
    Agent?: string;
    Text?: string;
    Date?: Date;
}

export interface ODataQueryContext {
    DefaultQuerySettings?: DefaultQuerySettings;
    Model?: IEdmModel;
    ElementType?: IEdmType;
    NavigationSource?: IEdmNavigationSource;
    ElementClrType?: string;
    Path?: ODataPath;
    RequestContainer?: IServiceProvider;
}

export interface DefaultQuerySettings {
    EnableExpand: boolean;
    EnableSelect: boolean;
    EnableCount: boolean;
    EnableOrderBy: boolean;
    EnableFilter: boolean;
    MaxTop?: number;
    EnableSkipToken: boolean;
}

export interface IEdmModel {
    SchemaElements?: IEdmSchemaElement[];
    VocabularyAnnotations?: IEdmVocabularyAnnotation[];
    ReferencedModels?: IEdmModel[];
    DeclaredNamespaces?: string[];
    DirectValueAnnotationsManager?: IEdmDirectValueAnnotationsManager;
    EntityContainer?: IEdmEntityContainer;
}

export interface IEdmSchemaElement {
    SchemaElementKind: EdmSchemaElementKind;
    Namespace?: string;
}

export enum EdmSchemaElementKind {
    None = 0,
    TypeDefinition = 1,
    Term = 2,
    Action = 3,
    EntityContainer = 4,
    Function = 5,
}

export interface IEdmVocabularyAnnotation {
    Qualifier?: string;
    Term?: IEdmTerm;
    Target?: IEdmVocabularyAnnotatable;
    Value?: IEdmExpression;
}

export interface IEdmTerm {
    Type?: IEdmTypeReference;
    AppliesTo?: string;
    DefaultValue?: string;
}

export interface IEdmTypeReference {
    IsNullable: boolean;
    Definition?: IEdmType;
}

export interface IEdmType {
    TypeKind: EdmTypeKind;
}

export enum EdmTypeKind {
    None = 0,
    Primitive = 1,
    Entity = 2,
    Complex = 3,
    Collection = 4,
    EntityReference = 5,
    Enum = 6,
    TypeDefinition = 7,
    Untyped = 8,
    Path = 9,
}

export interface IEdmVocabularyAnnotatable {}

export interface IEdmExpression {
    ExpressionKind: EdmExpressionKind;
}

export enum EdmExpressionKind {
    None = 0,
    BinaryConstant = 1,
    BooleanConstant = 2,
    DateTimeOffsetConstant = 3,
    DecimalConstant = 4,
    FloatingConstant = 5,
    GuidConstant = 6,
    IntegerConstant = 7,
    StringConstant = 8,
    DurationConstant = 9,
    Null = 10,
    Record = 11,
    Collection = 12,
    Path = 13,
    If = 14,
    Cast = 15,
    IsType = 16,
    FunctionApplication = 17,
    LabeledExpressionReference = 18,
    Labeled = 19,
    PropertyPath = 20,
    NavigationPropertyPath = 21,
    DateConstant = 22,
    TimeOfDayConstant = 23,
    EnumMember = 24,
    AnnotationPath = 25,
}

export interface IEdmDirectValueAnnotationsManager {}

export interface IEdmEntityContainer {
    Elements?: IEdmEntityContainerElement[];
}

export interface IEdmEntityContainerElement {
    ContainerElementKind: EdmContainerElementKind;
    Container?: IEdmEntityContainer;
}

export enum EdmContainerElementKind {
    None = 0,
    EntitySet = 1,
    ActionImport = 2,
    FunctionImport = 3,
    Singleton = 4,
}

export interface IEdmNavigationSource {
    NavigationPropertyBindings?: IEdmNavigationPropertyBinding[];
    Path?: IEdmPathExpression;
    Type?: IEdmType;
}

export interface IEdmNavigationPropertyBinding {
    NavigationProperty?: IEdmNavigationProperty;
    Target?: IEdmNavigationSource;
    Path?: IEdmPathExpression;
}

export interface IEdmNavigationProperty {
    Partner?: IEdmNavigationProperty;
    OnDelete: EdmOnDeleteAction;
    ContainsTarget: boolean;
    ReferentialConstraint?: IEdmReferentialConstraint;
}

export enum EdmOnDeleteAction {
    None = 0,
    Cascade = 1,
}

export interface IEdmReferentialConstraint {
    PropertyPairs?: EdmReferentialConstraintPropertyPair[];
}

export interface EdmReferentialConstraintPropertyPair {
    DependentProperty?: IEdmStructuralProperty;
    PrincipalProperty?: IEdmStructuralProperty;
}

export interface IEdmStructuralProperty {
    DefaultValueString?: string;
}

export interface IEdmPathExpression {
    PathSegments?: string[];
    Path?: string;
}

export interface ODataPath {
    EdmType?: IEdmType;
    NavigationSource?: IEdmNavigationSource;
    Segments?: ODataPathSegment[];
    PathTemplate?: string;
    Path?: ODataPathSegment[];
}

export interface ODataPathSegment {
    EdmType?: IEdmType;
    Identifier?: string;
}

export interface IServiceProvider {}

export interface ODataRawQueryOptions {
    Filter?: string;
    Apply?: string;
    OrderBy?: string;
    Top?: string;
    Skip?: string;
    Select?: string;
    Expand?: string;
    Count?: string;
    Format?: string;
    SkipToken?: string;
    DeltaToken?: string;
}

export interface SelectExpandQueryOption {
    Context?: ODataQueryContext;
    RawSelect?: string;
    RawExpand?: string;
    Validator?: SelectExpandQueryValidator;
    SelectExpandClause?: SelectExpandClause;
    LevelsMaxLiteralExpansionDepth: number;
}

export interface SelectExpandQueryValidator {}

export interface SelectExpandClause {
    SelectedItems?: SelectItem[];
    AllSelected: boolean;
}

export interface SelectItem {}

export interface ApplyQueryOption {
    Context?: ODataQueryContext;
    ResultClrType?: string;
    ApplyClause?: ApplyClause;
    RawValue?: string;
}

export interface ApplyClause {
    Transformations?: TransformationNode[];
}

export interface TransformationNode {
    Kind: TransformationNodeKind;
}

export enum TransformationNodeKind {
    Aggregate = 0,
    GroupBy = 1,
    Filter = 2,
    Compute = 3,
    Expand = 4,
}

export interface FilterQueryOption {
    Context?: ODataQueryContext;
    Validator?: FilterQueryValidator;
    FilterClause?: FilterClause;
    RawValue?: string;
}

export interface FilterQueryValidator {}

export interface FilterClause {
    Expression?: SingleValueNode;
    RangeVariable?: RangeVariable;
    ItemType?: IEdmTypeReference;
}

export interface QueryNode {
    Kind: QueryNodeKind;
}

export interface SingleValueNode extends QueryNode {
    TypeReference?: IEdmTypeReference;
    Kind: QueryNodeKind;
}

export enum QueryNodeKind {
    None = 0,
    Constant = 1,
    Convert = 2,
    NonResourceRangeVariableReference = 3,
    BinaryOperator = 4,
    UnaryOperator = 5,
    SingleValuePropertyAccess = 6,
    CollectionPropertyAccess = 7,
    SingleValueFunctionCall = 8,
    Any = 9,
    CollectionNavigationNode = 10,
    SingleNavigationNode = 11,
    SingleValueOpenPropertyAccess = 12,
    SingleResourceCast = 13,
    All = 14,
    CollectionResourceCast = 15,
    ResourceRangeVariableReference = 16,
    SingleResourceFunctionCall = 17,
    CollectionFunctionCall = 18,
    CollectionResourceFunctionCall = 19,
    NamedFunctionParameter = 20,
    ParameterAlias = 21,
    EntitySet = 22,
    KeyLookup = 23,
    SearchTerm = 24,
    CollectionOpenPropertyAccess = 25,
    CollectionComplexNode = 26,
    SingleComplexNode = 27,
    Count = 28,
    SingleValueCast = 29,
    CollectionPropertyNode = 30,
    AggregatedCollectionPropertyNode = 31,
    In = 32,
    CollectionConstant = 33,
}

export interface RangeVariable {
    Name?: string;
    TypeReference?: IEdmTypeReference;
    Kind: number;
}

export interface OrderByQueryOption {
    Context?: ODataQueryContext;
    OrderByNodes?: OrderByNode[];
    RawValue?: string;
    Validator?: OrderByQueryValidator;
    OrderByClause?: OrderByClause;
}

export interface OrderByNode {
    Direction: OrderByDirection;
}

export enum OrderByDirection {
    Ascending = 0,
    Descending = 1,
}

export interface OrderByQueryValidator {}

export interface OrderByClause {
    ThenBy?: OrderByClause;
    Expression?: SingleValueNode;
    Direction: OrderByDirection;
    RangeVariable?: RangeVariable;
    ItemType?: IEdmTypeReference;
}

export interface SkipQueryOption {
    Context?: ODataQueryContext;
    RawValue?: string;
    Value: number;
    Validator?: SkipQueryValidator;
}

export interface SkipQueryValidator {}

export interface SkipTokenQueryOption {
    RawValue?: string;
    Context?: ODataQueryContext;
    Validator?: SkipTokenQueryValidator;
    QuerySettings?: ODataQuerySettings;
    QueryOptions?: ODataQueryOptions;
}

export interface SkipTokenQueryValidator {}

export interface ODataQuerySettings {
    EnsureStableOrdering: boolean;
    HandleNullPropagation: HandleNullPropagationOption;
    EnableConstantParameterization: boolean;
    EnableCorrelatedSubqueryBuffering: boolean;
    PageSize?: number;
    HandleReferenceNavigationPropertyExpandFilter: boolean;
}

export enum HandleNullPropagationOption {
    Default = 0,
    True = 1,
    False = 2,
}

export interface TopQueryOption {
    Context?: ODataQueryContext;
    RawValue?: string;
    Value: number;
    Validator?: TopQueryValidator;
}

export interface TopQueryValidator {}

export interface CountQueryOption {
    Context?: ODataQueryContext;
    RawValue?: string;
    Value: boolean;
    Validator?: CountQueryValidator;
}

export interface CountQueryValidator {}

export interface ODataQueryValidator {}

export interface ODataQueryOptionsOfFileDTO extends ODataQueryOptions {
    IfMatch?: ETagOfFileDTO;
    IfNoneMatch?: ETagOfFileDTO;
}

export interface ETagOfFileDTO extends ETag {}

export interface ODataQueryOptionsOfImageDTO extends ODataQueryOptions {
    IfMatch?: ETagOfImageDTO;
    IfNoneMatch?: ETagOfImageDTO;
}

export interface ETagOfImageDTO extends ETag {}

/** Poco object for the creation of a canvas */
export interface NewCanvasDTO {
    /** Size of this Canvas in units relative to its contents
(e.g. not in pixels or meters, but in abstract units
depending on the place where it is actually rendered in a UI
and the relative sizes of its contents) */
    size?: Dimension;
}

/** DTO object for a CanvasCollection. */
export interface CanvasCollectionDTO {
    /** Id of the CanvasCollection */
    id: string;
    /** Id of the owner of this CanvasCollection */
    canvasCollectionOwnerId: string;
    /** Human readable Name of the CanvasCollection for use in UI elements */
    name?: string;
}

/** DTO object for a ProjectCanvasCollection. */
export interface ProjectCanvasCollectionDTO extends CanvasCollectionDTO {
    /** Id of the Project that the CanvasCollection belongs to */
    projectId: string;
    /** Type of this ProjectCanvasCollection */
    type: ProjectCanvasCollectionType;
}

export enum ProjectCanvasCollectionType {
    Presentation = <any>"presentation",
    Journal = <any>"journal",
}

export interface NewTimelineEntryDTO {
    /** Type of operation that was performed */
    type: TimelineEntryType;
    /** Set of type specific properties that belong to the operation (schemaless) */
    properties: { [key: string]: any };
}

export interface TimelineEntryDTO extends NewTimelineEntryDTO {
    /** Set of type specific properties that belong to the operation (schemaless) */
    properties: { [key: string]: any };
    /** Id of the timeline entry */
    id: string;
    /** Id of the project this timeline entry belongs to */
    projectId: string;
    /** Id of the representative this timeline entry belongs to */
    representativeId: string;
    /** Indicates that this timeline entry is highlighted (important result) */
    highlighted: boolean;
    /** Time at which the operation was performed */
    timeStamp: Date;
    /** Optional snapshot of belonging to the operation */
    snapshot?: SnapshotDTO;
    /** Optional notes for the entry */
    notes?: string;
}

/** DTO object for snapshots. */
export interface SnapshotDTO extends ImageMediaObjectDTO {
    /** Id of the timeline entry corresponding to this snapshot */
    timelineEntryId: string;
}

export enum TimelineEntryType {
    SpectrumAnalysis = <any>"spectrumanalysis",
    SpectrogramAnalysis = <any>"spectrogramanalysis",
    NearfieldAnalysis = <any>"nearfieldanalysis",
    FarfieldAnalysis = <any>"farfieldanalysis",
    TimeAnalysis = <any>"timeanalysis",
    Measurement = <any>"measurement",
}

/** DTO object for creating new snapshot. */
export interface NewSnapshotDTO {
    /** Data of the image */
    data: string;
}

export interface License {
    Id: string;
    LicenseHolderId: string;
    LicenseKind?: LicenseKind;
    Duration?: SoramaTimeSpan;
    DeviceProperties?: LicenseDeviceProperties;
}

export interface LicenseKind {
    Id: number;
    LicenseKindName?: string;
    LicenseKindTag?: string;
    Properties?: LicenseKindProperties;
}

export interface LicenseKindProperties {
    CreditsBufferCap: number;
    UserCap: number;
    DepartmentCap: number;
    SoundCameraCap: number;
    StorageBytes: number;
    HasForumSupport: boolean;
    HasFullSupport: boolean;
    CanSellCreditsPacks: boolean;
    CanSellTokensPacks: boolean;
    CanSellLicenses: boolean;
    IsMembershipLicense: boolean;
    LicenseType: LicenseType;
}

export enum LicenseType {
    Membership = 0,
    FeatureHandheld = 1,
    FeatureL642 = 2,
    FeatureSV600 = 3,
}

export interface SoramaTimeSpan {
    Milliseconds: number;
    Seconds: number;
    Minutes: number;
    Hours: number;
    Days: number;
    Months: number;
    Years: number;
}

export interface LicenseDeviceProperties {
    DeviceId?: string;
    DeviceType: LicenseDeviceType;
}

export enum LicenseDeviceType {
    None = 0,
    Handheld = 1,
    L642 = 2,
    SV600 = 3,
}

export enum PermissionFlags {
    None = 0,
    Create = 1,
    Read = 2,
    Update = 4,
    Delete = 8,
    All = 15,
}

export interface PermissionDTO {
    /** The Id of the Permission. */
    Id: number;
    /** Flags defining what kind of operations this Permission grants on its PermissionTarget for its PermissionHolders */
    PermissionFlags: PermissionFlags;
    /** The PermissionTarget describing the kind of entity or operation to which this Permission applies. */
    PermissionTarget: PermissionTargets;
    /** The date at which this permission was created. */
    DateStart: Date;
    /** The date at which this permission becomes/became invalid. */
    DateEnd?: Date;
    /** The name of the type of this Permission.
Used to see which type of permission it is after serialisation to JSON.
(to discern between global and non-global permissions without having to check for the presence of the EntityId properties). */
    TypeName?: string;
    /** The human-redable name of the Referenced Entity (if any) */
    ReferencedEntityName?: string;
    /** The Id of the referenced Entity (if any) */
    ReferencedEntityId?: string;
}

export enum PermissionTargets {
    BusinessUnit = 0,
    Measurement = 1,
    Project = 2,
    RepresentativeGroup = 3,
    Representative = 4,
    CreditsPack = 5,
    Customer = 6,
    Hardware = 7,
    License = 8,
    LicenseBundle = 9,
    LicenseBundleKind = 10,
    LicenseKind = 11,
    LicenseTransaction = 12,
    MediaObject = 13,
    Permission = 14,
    RepresentativeGroupTemplate = 15,
    TokensPack = 16,
    Credits = 17,
    Tokens = 18,
}

export interface PermissionHolder {
    Id: string;
}

export interface CreditsMutation {
    Id: number;
    CreditBalanceId: string;
    TimeStamp: Date;
    User?: string;
    Amount: number;
    Data?: string;
}

export interface CreditReport {
    From: Date;
    To: Date;
    CreditsSpend: number;
    CreditsReceived: number;
    /** The saldo on the last date */
    CreditSaldo: number;
    Entries?: CreditReportEntry[];
}

export interface CreditReportEntry {
    ActionBookId: string;
    ActionBookName?: string;
    Amount: number;
    NumberOfTransactions: number;
}

/** A CreditsMutation for performing credit mutations from the WebAPI */
export interface NewCreditsMutation {
    /** The amount of credits to add (to substract, make this a negative number). */
    amount: number;
    /** The description of the mutation. */
    description?: string;
}

/** Type only used for adding new permissions to a representative in the /api/Representatives/AssignedPermissions method. Is not saved in the database and hence not located in the Datamodel. */
export interface NewPermission {
    /** The name of the type of the new permission */
    PermissionTypeName: string;
    /** The PermissionFlags of the new permission */
    PermissionFlags: PermissionFlags;
    /** The target of the new permission */
    PermissionTarget: PermissionTargets;
    /** The Id of the entity this permission applies to.
Not required for a GlobalPermission or a Permission template. */
    PermissionTypeEntityId?: string;
    /** The date and time at which this permission becomes invalid.
If null/not set, this Permission is valid indefinately.
Not required for a Permission template. */
    DateEnd?: Date;
}

export interface RepresentativeGroupDTO {
    /** The Id of the RepresentativeGroup. */
    Id: string;
    /** The Id of the RepresentativeGroupTemplate this RepresentativeGroup was created from, if any */
    RepresentativeGroupTemplateId?: string;
    /** The Id of the BusinessUnit this RepresentativeGroup belongs to. */
    BusinessUnitId: string;
    /** The Name of this RepresentativeGroup. */
    Name?: string;
}

export interface RepresentativeDTO {
    /** The Id of the Representative. */
    Id: string;
    /** The Id of the BusinessUnit this Representative belongs to. */
    BusinessUnitId: string;
    /** The Id of the RepresentatvieGroup this Representative is in. */
    RepresentativeGroupId: string;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    EmailConfirmed: boolean;
    PhoneNumber?: string;
    PhoneNumberConfirmed: boolean;
    TwoFactorEnabled: boolean;
    LockoutEndDateUtc?: Date;
    LockoutEnabled: boolean;
    AccessFailedCount: number;
    CreateDate: Date;
    LastLoginDate?: Date;
    LastPasswordChangedDate?: Date;
    LastLockoutDate?: Date;
    LastPasswordFailureDate?: Date;
}

export interface Representative extends PermissionHolder {
    RepresentativeId: string;
    BusinessUnitId: string;
    RepresentativeGroupId: string;
    User?: SoramaUser;
}

export interface IdentityUserOfGuidAndSoramaUserLoginAndSoramaUserRoleAndSoramaUserClaim {
    Email?: string;
    EmailConfirmed: boolean;
    PasswordHash?: string;
    SecurityStamp?: string;
    PhoneNumber?: string;
    PhoneNumberConfirmed: boolean;
    TwoFactorEnabled: boolean;
    LockoutEndDateUtc?: Date;
    LockoutEnabled: boolean;
    AccessFailedCount: number;
    Roles?: SoramaUserRole[];
    Claims?: SoramaUserClaim[];
    Logins?: SoramaUserLogin[];
    Id: string;
    UserName?: string;
}

export interface SoramaUser extends IdentityUserOfGuidAndSoramaUserLoginAndSoramaUserRoleAndSoramaUserClaim {
    FirstName?: string;
    LastName?: string;
    CreateDate: Date;
    LastLoginDate?: Date;
    LastActivityDate?: Date;
    LastPasswordChangedDate?: Date;
    LastLockoutDate?: Date;
    LastPasswordFailureDate?: Date;
}

export interface IdentityUserRoleOfGuid {
    UserId: string;
    RoleId: string;
}

export interface SoramaUserRole extends IdentityUserRoleOfGuid {}

export interface IdentityUserClaimOfGuid {
    Id: number;
    UserId: string;
    ClaimType?: string;
    ClaimValue?: string;
}

export interface SoramaUserClaim extends IdentityUserClaimOfGuid {}

export interface IdentityUserLoginOfGuid {
    LoginProvider?: string;
    ProviderKey?: string;
    UserId: string;
}

export interface SoramaUserLogin extends IdentityUserLoginOfGuid {}

export interface UpdateBusinessUnitDTO {
    id: string;
    isActive: boolean;
    market: Market;
    name: string;
}

export enum Market {
    Other = <any>"Other",
    LivableCities = <any>"Livable Cities",
    LivableBuildings = <any>"Livable Buildings",
    SustainableProducts = <any>"Sustainable Products",
    SustainableIndustries = <any>"Sustainable Industries",
}

/** Type only used for registering new representativeGroups. Is not saved in the database and hence not located in the Datamodel. */
export interface NewRepresentativeGroup {
    name: string;
}

/** DTO object containing user information for creating a new representative. */
export interface NewRepresentativePropertiesDTO {
    userName: string;
    email: string;
    firstName?: string;
    lastName?: string;
}

/** DTO object containing user information for creating a new representative. This object also contains an id for the representative group the representative should be placed in. */
export interface NewRepresentativeDTO extends NewRepresentativePropertiesDTO {
    representativeGroupId: string;
}

export interface Location {
    CoordinateSystemId?: number;
    Longitude?: number;
    Latitude?: number;
}

export enum PartnerLevels {
    None = <any>"None",
    PortalPartner = <any>"PortalPartner",
    BronzeCertified = <any>"BronzeCertified",
    SilverCertified = <any>"SilverCertified",
    GoldCertified = <any>"GoldCertified",
}

export enum PartnerSpecialisms {
    AnalysisAndResearch = <any>"AnalysisAndResearch",
    ModelingAndSpecification = <any>"ModelingAndSpecification",
    DesignAndCreating = <any>"DesignAndCreating",
    ValidationAndTesting = <any>"ValidationAndTesting",
    EvaluationAndCommunication = <any>"EvaluationAndCommunication",
    Other = <any>"Other",
}

export interface NewBusinessUnitPropertiesDTO {
    /** The name of the new Customer */
    name: string;
    /** The market of the new Customer */
    market: Market;
}

/** Type only used for registering new BusinessUnit. Is not saved in the database and hence not located in the Datamodel. */
export interface NewBusinessUnitDTO extends NewBusinessUnitPropertiesDTO {
    /** The existing licences for the new BusinessUnit if a new License is not created. */
    existingLicenses?: ActivatedExistingLicense[];
    /** The new licence for the new BusinessUnit if an existing License is not sold.
If ExistingLicense is also set, this is ignored. */
    newLicenses?: ActivatedNewLicense[];
}

/** Type used for selling existing Licenses. Is not saved in the database and hence not located in the Datamodel. */
export interface ExistingLicense {
    /** The Id of the existing License */
    licenseId: string;
}

/** Type used for registering activated existing Licenses. Is not saved in the database and hence not located in the Datamodel. */
export interface ActivatedExistingLicense extends ExistingLicense {
    /** The date at which the license starts. */
    dateStart: Date;
}

/** Type used for registering new Licenses. Is not saved in the database and hence not located in the Datamodel. */
export interface NewLicense {
    /** The kind of the new license. */
    licenseKind: string;
    /** The duration of the new license. */
    duration: SoramaTimeSpan;
}

/** Type used for registering activated new Licenses. Is not saved in the database and hence not located in the Datamodel. */
export interface ActivatedNewLicense extends NewLicense {
    /** The date at which the license starts. */
    dateStart: Date;
}

/** DTO Object containing properties required for creating a new businessunit and user when registering a device. */
export interface NewBusinessUnitWithRepresentativeFromDeviceDTO {
    /** Properties for the to-be-created businessunit */
    businessUnit: NewBusinessUnitPropertiesFromDeviceDTO;
    /** Properties for the to-be-created representative for the businessunit */
    representative: NewRepresentativePropertiesDTO;
}

export interface NewBusinessUnitPropertiesFromDeviceDTO {
    /** The name of the new Customer */
    name: string;
}

/** Type only used for registering new Departments. Is not saved in the database and hence not located in the Datamodel. */
export interface NewDepartmentDTO extends NewBusinessUnitDTO {}

/** Type only used for registering new Customers. Is not saved in the database and hence not located in the Datamodel. */
export interface NewCustomerDTO extends NewBusinessUnitDTO {}

export interface BusinessUnitMetadata {
    Id: string;
    Location?: DbGeography;
    PartnerLevel?: string;
    PartnerSalesPitch?: string;
    PersonalizedPage: string;
    LogoImageId: string;
    Website?: string;
    Video?: string;
    PartnerSpecialism?: string;
}

export interface DbGeography {
    Geography?: DbGeographyWellKnownValue;
}

export interface DbGeographyWellKnownValue {
    CoordinateSystemId: number;
    WellKnownText?: string;
    WellKnownBinary?: string;
}

/** Business Unit DTO object for calls that return BusinessUnit information This DTO may contain all information that the READ permission should grant on the particular BusinessUnit. */
export interface BusinessUnitDTO {
    Id: string;
    Name?: string;
    CreateDate: Date;
    /** Boolean to indicate whether this businessunit is currently active */
    IsActive: boolean;
    Market: Market;
}

/** A customer is essentially a BusinessUnit with more information about credits, tokens and memberships. Elevated permission is required for this oibject. */
export interface CustomerDTO extends BusinessUnitDTO {
    /** Currently active membership of this customer. */
    CurrentActiveMembership?: ActivatedLicenseDTO;
    /** Next active membership of this customer. */
    NextActiveMembership?: ActivatedLicenseDTO;
    /** Latest active membership of this customer. */
    LatestActiveMembership?: ActivatedLicenseDTO;
    /** Credit balance of this customer. */
    CreditBalance?: CreditBalanceDTO;
    /** True if one or more customers */
    HasCustomers: boolean;
    /** Set of token balances of this customer. */
    TokenBalances?: TokenBalanceDTO[];
    /** Date of the last login of a user of this businessunit. */
    LastUserLogin?: Date;
    /** The type of the customer of this businessunit. */
    CustomerType: CustomerType;
}

export interface LicenseDTO {
    Id: string;
    LicenseKind?: LicenseKind;
    Duration?: SoramaTimeSpan;
}

export interface ActivatedLicenseDTO extends LicenseDTO {
    /** The DateTime at which the license starts/started */
    DateStart: Date;
    /** The DateTime on which the license ends/ended */
    DateEnd: Date;
    /** Checks if this license has been manually canceled (DateEnd before DateStart + Duration). */
    IsCanceled: boolean;
    /** Checks if this license start date has passed and its end date is in the future. */
    IsValid: boolean;
}

export interface CreditBalanceDTO {
    CreditSaldo: number;
    DebetSaldo: number;
    Saldo: number;
}

export interface TokenBalanceDTO {
    DebetSaldo: number;
    CreditSaldo: number;
}

export enum CustomerType {
    Customer = <any>"Customer",
    Reseller = <any>"Reseller",
    ResellerCustomer = <any>"Reseller's customer",
}

export interface CustomerRelationDTO {
    /** The Id of this CustomerRelation */
    Id: string;
    /** The Id of the BusinessUnit which is the service provider of the customer. */
    ServiceProviderId: string;
    /** Name of the ServicesProviders BusinessUnit. */
    ServiceProviderName?: string;
    /** The Id of the BusinessUnit which is the customer of the service provider. */
    CustomerId: string;
    /** Name of the Customers BusinessUnit. */
    CustomerName?: string;
    /** The DateTime at which the relation was created. */
    TimeStamp: Date;
    /** The DateTime at which the relation was terminated. */
    EndDate?: Date;
}

export interface RepresentativeGroupTemplate extends PermissionHolder {
    RepresentativeGroupTemplateId: number;
    Name?: string;
}

export interface ProjectDTO {
    /** Id of this project */
    id: string;
    /** Id of the business unit that owns this project */
    ownerId: string;
    /** Creation date of the project */
    created: Date;
    /** Name of the project */
    name: string;
    /** Description of the projection */
    description?: string;
}

export interface MongoDocument {
    id: string;
}

export interface GenericMeasurement extends MongoDocument {
    name?: string;
    notes?: string;
    storageId?: string;
    projectId: string;
    start: Date;
    ownerId: string;
    sorId?: string;
    created: Date;
    uraProperties?: URAProperties;
    duration: number;
    distance?: number;
    mutedSensors?: Point3D[];
    audioDataUnit: AudioMeasurementDataUnit;
    audioDataLayout: AudioMeasurementDataLayout;
    videoDataFormat: VideoMeasurementDataFormat;
    parts?: MeasurementPart[];
    metadata?: { [key: string]: any };
    hasUploadedRawSorFile?: boolean;
    specialMeasurementType?: SpecialMeasurementType;
    specialMeasurementInfo?: any;
    computedMeasurementProperties?: ComputedMeasurementProperties;
    selectedImage?: string;
    links?: MeasurementMediaObjectLink[];
    isComputedMeasurement: boolean;
    computedMeasurementSourceId?: string;
    computedMeasurementSource?: GenericMeasurement;
}

export interface URAProperties {
    width: number;
    height: number;
    sensorWidth: number;
    sensorHeight: number;
    spacing: number;
}

export interface Point3D {
    x: number;
    y: number;
    z: number;
}

export enum AudioMeasurementDataUnit {
    FullScale = 0,
    Pascal = 1,
}

export enum AudioMeasurementDataLayout {
    RAWInt32ChannelContiguous = 0,
    RAWFloat32ChannelContiguous = 1,
}

export enum VideoMeasurementDataFormat {
    MJPEG = 0,
    VP8 = 1,
    VP9 = 2,
}

export interface MeasurementPart {
    measurementType: MeasurementPartType;
    position?: Point3D;
    device?: MeasurementDevice;
    dataHash?: string;
    dataSize?: number;
    dataContainer?: string;
}

export enum MeasurementPartType {
    Audio = 1,
    Video = 2,
}

export interface MeasurementDevice {
    hardwareModuleIds?: string[];
    sensorPositions?: Point3D[];
    sampleRate: number;
    properties: DeviceProperties;
    correctionCurve: number[];
}

export enum WebcamImageOrientation {
    Default = 0,
    Rotate90 = 1,
    Rotate180 = 2,
    Rotate270 = 3,
}

export enum SpecialMeasurementType {
    SRI = <any>"SRI",
    RT = <any>"RT",
    SLR = <any>"SLR",
    LD = <any>"LD",
    PDD = <any>"PDD",
    STC = <any>"STC",
}

export enum SorXMeasurementTypeEnum {
    Image = "image",
    Video = "video",
    LeakDetection = "leakDetection",
    PartialDischarge = "partialDischarge",
    MechanicalInspection = "mechanicalInspection",
}

export interface ComputedMeasurementProperties {
    ProcessorType?: string;
    Properties?: { [key: string]: any };
}

export interface MediaObjectLink {
    mediaObjectId: string;
    created: Date;
    properties?: LinkProperties;
}

export interface MeasurementMediaObjectLink extends MediaObjectLink {
    targetId: string;
    type: MediaObjectLinkType;
}

export enum MediaObjectLinkType {
    Project = 0,
    Measurement = 1,
    Canvas = 2,
}

export interface ODataQueryOptionsOfTimelineEntryDTO extends ODataQueryOptions {
    IfMatch?: ETagOfTimelineEntryDTO;
    IfNoneMatch?: ETagOfTimelineEntryDTO;
}

export interface ETagOfTimelineEntryDTO extends ETag {}

export interface UpdateProjectDTO {
    name?: string;
    description?: string;
}

export interface NewProjectDTO {
    name: string;
    description?: string;
}

/** Poco object for the creation of a CanvasCollection. */
export interface NewCanvasCollectionDTO {
    /** Human readable Name of the CanvasCollection for use in UI elements */
    name?: string;
}

/** Type used for registering full CAMs, a microphone array rack with arrays, frontend connectors and webcams. */
export interface NewCAM {
    /** The new Microphone ArrayRack with microphone arrays and frontendconnectors to register */
    newMicrophoneArrayRack?: NewMicrophoneArrayRack;
    /** The new Webcam to register together with the rack. Unknown because we still have to look up the configuration for calibration, and generate a moduleId when created. */
    newWebcam?: NewUnknownWebcam;
}

/** Type used for registering new Microphone Array Racks. */
export interface NewMicrophoneArrayRack {
    /** The ModuleId of the new Microphone Array Rack */
    moduleId: string;
    /** The PhysicalId of the new Microphone Array Rack */
    physicalId: string;
    /** The module type of the array rack */
    moduleType: ModuleTypes;
    /** The new Microphone Arrays to add to the database and attach to the new Microphone Array Rack after creation */
    newMicrophoneArrays?: NewMicrophoneArray[];
    /** The new FrontEnd Connectors to add to the database and attach to the new Microphone Array Rack after creation */
    newFrontEndConnectors?: NewFrontEndConnector[];
    /** The Markers to add to the new Microphone Array Rack */
    markers?: Marker[];
    /** The type of the Markers to add to the new Microphone Array Rack */
    markerType?: MarkerType;
    /** The (xml formatted) contents of the MarkerCollection file for adding Markers to the new Microphone Array Rack */
    markerCollectionFileContents?: string;
}

export enum ModuleTypes {
    MicrophoneArray8X8Type = 0,
    DMADAQType = 1,
    WebcamType = 2,
    ManualMotionSystem = 3,
    AutomaticMotionSystem = 4,
    ScanMModuleRack = 5,
    CamModuleRack = 6,
    Cam256ModuleRack = 7,
    IV64 = 8,
    L642 = 9,
}

/** Type used for registering new Microphone Arrays. */
export interface NewMicrophoneArray {
    /** The ModuleId of the new Microphone Array */
    moduleId: string;
    /** The PhysicalId of the new Microphone Array */
    physicalId: string;
    /** The type of the microphone array (e.g. Sunflower or rectangular) */
    microphoneArrayType: MicrophoneArrayType;
    /** The ModuleId of the Microphone Array Rack to attach this Microphone Array to */
    microphoneArrayRackModuleId?: string;
    /** The position of this Microphone Array in the specified Microphone Array Rack */
    position?: Coordinate3D;
}

export enum MicrophoneArrayType {
    Rectangular = 0,
    Sunflower = 1,
}

export interface Coordinate3D {
    X: number;
    Y: number;
    Z: number;
}

/** Type used for registering new Microphone Arrays. */
export interface NewFrontEndConnector {
    /** The ModuleId of the new DMADAQ */
    moduleId: string;
    /** The PhysicalId of the new DMADAQ */
    physicalId: string;
    /** The type of DMADAQ hardware. Used by the Web API to insert (pre-defined) DecimatorProperties into the DMADAQReference created from this NewDmadaq. */
    dmadaqType: DmadaqTypes;
    /** MicrophoneArrayRackModuleId of the rack this connector is attached to. */
    microphoneArrayRackModuleId?: string;
}

/** Enum defining DMADAQ hardware types used by the Web API to insert pre-defined DecimatorProperties. */
export enum DmadaqTypes {
    Dmadaq = 0,
    Zynq = 1,
}

export interface Marker {
    MarkerId: number;
    Dimension?: Dimension;
    Position?: Coordinate3D;
}

export enum MarkerType {
    ArucoMarker = 0,
    CrossMarker = 1,
}

export interface NewUnknownWebcam {
    /** The VendorId of the new Webcam */
    vendorId: number;
    /** The ProductId of the new Webcam */
    productId: number;
    /** Whether or not to the viewport of the device should be cropped to a widescreen ratio after rotation and sensor offset correction */
    cropToWidescreen: boolean;
    /** The Name/Type of the new Webcam */
    name?: string;
    /** Offset of the center of the sensor with respect to the center of the in promille of the image size */
    sensorOffsetCorrection?: Coordinate2D;
    /** The ModuleId of the Microphone Array Rack to attach this Webcam to */
    microphoneArrayRackModuleId?: string;
    /** The position of this Webcam relative to the Microphone Array Rack center */
    position?: Coordinate3D;
    /** The orientation of the webcam relative to the Microphone Array Rack */
    webcamImageOrientation: WebcamImageOrientation;
}

export interface Coordinate2D {
    X: number;
    Y: number;
}

/** Type used for registering new Motion Devices. */
export interface NewMotionDevice {
    /** The ModuleId of the new Motion Device */
    moduleId: string;
    /** The PhysicalId of the new Motion Device */
    physicalId: string;
    /** Set to true if the Motion Device has to be moved manually. 
Set to false if the Motion Device can be moved automatically. */
    isManual: boolean;
    /** Set to true if the Motion Device has a fixed range over which it can move the attached Sound Camera. */
    hasFixedRange: boolean;
    /** The range of the Motion Device if it has a fixed range. */
    range?: Dimension;
}

export interface NewWebcam extends NewUnknownWebcam {
    /** The ModuleId of the new Webcam */
    moduleId: string;
    /** The Name/Type of the new Webcam */
    name: string;
    /** The calibration of the new Webcam */
    webcamCalibration: WebCamCalibration;
}

export interface WebCamCalibration {
    FocalX: number;
    FocalY: number;
    PrincipalX: number;
    PrincipalY: number;
}

export interface FrontEndDTO {
    /** The Hardware Id for this front end
This is identical to the MicrophoneArrayRack HardwareId and is merely here for convenience */
    HardwareId?: string;
    Rack?: MicrophoneArrayRackDTO;
    MicrophoneArrays?: MicrophoneArrayDTO[];
    Webcams?: WebcamDTO[];
    Connectors?: FrontEndConnectorDTO[];
}

export interface HardwareModuleDTO {
    /** The Hardware Id to uniquely identify this module with. 
Should be equal to the id of the id chip on the device if one is present, randomly generated otherwise. */
    HardwareId?: string;
    /** The label to group sets of hardware modules together. */
    Label?: string;
}

export interface SoramaHardwareModuleDTO extends HardwareModuleDTO {
    /** The Hardware Id to uniquely identify this module with. 
Should be equal to the id of the id chip on the device if one is present, randomly generated otherwise. */
    SerialNumber?: string;
}

export interface MicrophoneArrayRackDTO extends SoramaHardwareModuleDTO {
    MarkerCollection?: MarkerCollection;
    Dimension?: Dimension;
    MicrophoneArrayCoordinates?: Coordinate3D[];
}

export interface MarkerCollection {
    Markers?: Marker[];
    MicrophoneArrayRackHardwareId?: string;
    MarkerType: MarkerType;
}

export interface MicrophoneArrayDTO extends SoramaHardwareModuleDTO {
    MicrophoneArrayRackHardwareId?: string;
    Spacing?: Dimension;
    Sensors?: Dimension;
    MicrophoneArrayCalibrationId: string;
    MicrophoneArrayCalibration?: MicrophoneArrayCalibration;
    MicrophoneArrayType: MicrophoneArrayType;
}

export interface MicrophoneArrayCalibration {
    Id: string;
    CalibrationData?: number[];
    Version: number;
    Date?: string;
    OwnedModule?: OwnedModule;
    OwnedModuleId: string;
    PhysicalId?: string;
}

export interface OwnedModule {
    Id: number;
    ModuleOwnerId: string;
    ModuleId?: string;
    Module?: Module;
    Start: Date;
    End?: Date;
}

export interface Module {
    HardwareModule?: HardwareModule;
    ModuleId?: string;
    DateEntered: Date;
}

export interface HardwareModule {
    HardwareId?: string;
    Label?: string;
}

export interface WebcamDTO extends HardwareModuleDTO {
    MicrophoneArrayRackHardwareId?: string;
    Position?: Coordinate3D;
    WebcamImageOrientation: WebcamImageOrientation;
    Name?: string;
    VendorId: number;
    DeviceId: number;
    CropToWideScreen: boolean;
    SensorOffsetCorrection?: Coordinate2D;
    Calibration?: WebCamCalibration;
}

export interface FrontEndConnectorDTO extends SoramaHardwareModuleDTO {
    MicrophoneArrayRackHardwareId?: string;
    /** Decimator Properties of the Front End Connector */
    DecimatorProperties?: DecimatorProperties;
}

export interface DecimatorProperties {
    DecimatorNormalizationFactor: number;
    FixedpointFractionLength: number;
}

export interface OwnedHardwareModuleDTO extends HardwareModuleDTO {
    /** Id of the owner of this hardware module */
    Owner: string;
}

export interface SoramaHardwareModule extends HardwareModule {
    SerialNumber?: string;
}

export interface IV64 extends SoramaHardwareModule {}

export interface ListenerDTO extends SoramaHardwareModuleDTO {
    Kind?: string;
    NonActivatedLicenses?: SellableFeatureLicense[];
    ActivatedLicenses?: ActivatedFeatureLicense[];
}

export interface SellableLicense extends License {
    LicenseHolderId: string;
    SellableLicenseHolderId: string;
}

export interface SellableFeatureLicense extends SellableLicense {}

export interface ActivatedLicense extends License {
    IsValid: boolean;
    IsCanceled: boolean;
    WillBeOrHasBeenActive: boolean;
    LicenseHolderId: string;
    ActivatedLicenseHolderId: string;
    DateStart: Date;
    DateEnd: Date;
    Hidden: boolean;
}

export interface ActivatedFeatureLicense extends ActivatedLicense {}

export interface OwnedHardwareModuleDTOOfFrontEndConnectorDTO extends HardwareModuleDTO {
    Owner: string;
    Module?: FrontEndConnectorDTO;
}

export interface NamedOwnedHardwareModuleDTOOfFrontEndConnectorDTO extends OwnedHardwareModuleDTOOfFrontEndConnectorDTO {
    OwnerName?: string;
}

export interface OwnedHardwareModuleDTOOfMicrophoneArrayDTO extends HardwareModuleDTO {
    Owner: string;
    Module?: MicrophoneArrayDTO;
}

export interface NamedOwnedHardwareModuleDTOOfMicrophoneArrayDTO extends OwnedHardwareModuleDTOOfMicrophoneArrayDTO {
    OwnerName?: string;
}

export interface OwnedHardwareModuleDTOOfMicrophoneArrayRackDTO extends HardwareModuleDTO {
    Owner: string;
    Module?: MicrophoneArrayRackDTO;
}

export interface NamedOwnedHardwareModuleDTOOfMicrophoneArrayRackDTO extends OwnedHardwareModuleDTOOfMicrophoneArrayRackDTO {
    OwnerName?: string;
}

export interface OwnedHardwareModuleDTOOfMotionDeviceDTO extends HardwareModuleDTO {
    Owner: string;
    Module?: MotionDeviceDTO;
}

export interface NamedOwnedHardwareModuleDTOOfMotionDeviceDTO extends OwnedHardwareModuleDTOOfMotionDeviceDTO {
    OwnerName?: string;
}

export interface MotionDeviceDTO extends SoramaHardwareModuleDTO {
    Name?: string;
    HasFixedRange: boolean;
    Range?: Dimension;
    IsManual: boolean;
}

export interface OwnedHardwareModuleDTOOfWebcamDTO extends HardwareModuleDTO {
    Owner: string;
    Module?: WebcamDTO;
}

export interface NamedOwnedHardwareModuleDTOOfWebcamDTO extends OwnedHardwareModuleDTOOfWebcamDTO {
    OwnerName?: string;
}

export interface MicrophoneArray extends SoramaHardwareModule {
    MicrophoneArrayRackHardwareId?: string;
    Spacing?: Dimension;
    Sensors?: Dimension;
    MicrophoneArrayCalibrationId: string;
    Position?: Coordinate3D;
    MicrophoneArrayType: MicrophoneArrayType;
}

export interface FrontEndConnector extends SoramaHardwareModule {
    MicrophoneArrayRackHardwareId?: string;
    SamplingFrequency: number;
    DecimatorProperties?: DecimatorProperties;
}

export interface ThirdPartyHardwareModule extends HardwareModule {}

export interface Webcam extends ThirdPartyHardwareModule {
    MicrophoneArrayRackHardwareId?: string;
    Position?: Coordinate3D;
    WebcamImageOrientation: WebcamImageOrientation;
    Name?: string;
    VendorId: number;
    DeviceId: number;
    CropToWideScreen: boolean;
    SensorOffsetCorrection?: Coordinate2D;
    Calibration?: WebCamCalibration;
}

export enum SoundCameraModels {
    ScanA = 1,
    ScanB = 2,
    ScanM = 4,
    PilotCAM = 8,
    CAM = 16,
    CAM64 = 32,
    CAM1K = 64,
    IV64 = 128,
}

/** Network info about a device (e.g. IP address) */
export interface HardwareModuleNetworkInfoDTO {
    HardwareId: string;
    IPAddress?: string;
}

/** Type used for registering new CreditsPacks. Is not saved in the database and hence not located in the Datamodel. */
export interface NewCreditsPack {
    /** The kind of the new CreditsPack. */
    creditsPackKind: CreditsPackKinds;
    /** The amount of credits of the new CreditsPack if it is a custom amount */
    customCreditsAmount?: number;
}

export enum CreditsPackKinds {
    Custom = 0,
    S = 100000,
    M = 1500000,
    L = 5000000,
}

export interface CreditsPackTransactionDTO {
    /** The Id of the credit pack. */
    Id: number;
    /** The Id of the seller of the credit pack, if any */
    SellerCreditsHolderId?: string;
    /** The Id of the buyer of the credit pack, if any */
    BuyerCreditsHolderId?: string;
    /** The date at which the transaction took place, if any */
    TransactionTimeStamp?: Date;
}

export interface CreditsPackDTO extends CreditsPackTransactionDTO {
    /** The Id of the current owner of the credit pack. */
    CreditsHolderId: string;
    /** The kind of credit pack. */
    Kind?: string;
    /** The amount of credits in the credit pack. */
    CreditsAmount: number;
    /** The date at which the credit pack was activated, if activated. */
    DateActivated?: Date;
}

export interface TokensBalanceDTO {
    /** Id of this TokensBalance */
    Id: string;
    /** The Id of the TokensHolder which owns this TokensBalance */
    TokensHolderId: string;
    /** The ID of the TokensHolder which sold the tokens in this TokensBalance to the TokensHolder owning this TokensBalance */
    TokensSellerId: string;
    /** The current DebetSaldo on this balance */
    DebetSaldo: number;
    /** The current CreditSaldo on this balance */
    CreditSaldo: number;
}

export interface TokensPackTransactionDTO {
    /** Id of this TokensPack */
    Id: number;
    /** The Id of the TokensHolder who sold the TokensPack */
    SellerTokensHolderId: string;
    /** The Id of the TokensHolder who sold the TokensPack */
    BuyerTokensHolderId: string;
    /** The Id TokensHolder who originally created the Tokens
This is the party that will charge the tokens for its services. */
    CreatorTokensHolderId: string;
    /** The DateTime at which the transaction took place */
    TransactionTimeStamp: Date;
}

export interface TokensPackDTO extends TokensPackTransactionDTO {
    /** Id of the owner of this TokensPack */
    TokensHolderId: string;
    /** The kind of TokensPack this pack represents */
    Kind?: string;
    /** The amount of tokens granted by this pack */
    TokensAmount: number;
}

/** Type used for registering new TokensPacks. Is not saved in the database and hence not located in the Datamodel. */
export interface NewTokensPack {
    /** The kind of the new TokensPack. */
    tokensPackKind: TokensPackKinds;
    /** The amount of tokens of the new TokensPack if it is a custom amount */
    customTokensAmount?: number;
}

export enum TokensPackKinds {
    Custom = 0,
    S = 50,
    M = 200,
    L = 800,
}

/** A TokensMutation for performing token mutations from the WebAPI */
export interface NewTokensMutation {
    /** The amount of tokens. */
    amount: number;
    /** The description of the mutation. */
    description: string;
    /** The date at which the service was provided which resulted in this mutation. */
    serviceDate: Date;
}

export interface TokensMutation {
    Id: number;
    TokensBalanceId: string;
    TimeStamp: Date;
    User?: string;
    Amount: number;
    Data?: string;
    ServiceDate: Date;
}

export interface CustomerRequestDTO {
    /** Id of this ServiceProviderTransaction */
    Id: string;
    /** The BusinessUnit of the Customer in this transaction. */
    CustomerId: string;
    /** The BusinessUnit of the Customer in this transaction. */
    CustomerName?: string;
    /** The BusinessUnit which will become the new service provider for the customer. */
    NewServiceProviderId: string;
    /** The BusinessUnit of the Customer in this transaction. */
    NewServiceProviderName?: string;
    /** The date when the transaction will occur. If null the transaction will occur when it is completed by the new service provider. */
    StartDate: Date;
    /** The date when the Request was made. */
    Created: Date;
}

export interface ServiceProviderDTO {
    ServiceProviderId: string;
    Name?: string;
    Location?: Location;
    /** The current partner level */
    PartnerLevel?: string;
    /** A small sales pitch, defined by a partner. Maximum of 4000 characters */
    PartnerSalesPitch?: string;
    CompanyThumbnail?: string;
    Website?: string;
    Video?: string;
    PartnerSpecialism?: string[];
}

export interface LeakqResult {
    leakRate: number;
    range: LeakResultRange;
    leakType: As2LeakType;
}

export enum LeakResultRange {
    SmallerOrEqual = <any>"SmallerOrEqual",
    InRange = <any>"InRange",
    GreaterOrEqual = <any>"GreaterOrEqual",
}

export enum As2LeakType {
    Other = <any>"OtherLeakType",
    QuickConnect = <any>"Quick Connect",
    QuickConnectLeaks = <any>"QuickConnectLeaks",
    ThreadedCoupling = <any>"Threaded Coupling",
    ThreadedCap = <any>"ThreadedCap",
    Hose = <any>"Hose",
    HoleInHose = <any>"RubberHose_Hole",
    OpenEnd = <any>"Open End",
    OpenEnd2 = <any>"OpenEnd",
    Automatic = <any>"Automatic",
}

export interface As2ImportResult {
    linkedMeasurements?: GenericMeasurement[];
    linkedMediaObjects?: LinkedMediaObjectDTO[];
}

export interface MeasurementStorageInfo {
    measurementId: string;
    storageInfo: StorageInfo;
}

export enum StorageInfo {
    NotAvailable = 0,
    Allocated = 1,
    Available = 2,
}

export interface DataPart {
    id: number;
    offset: number;
    size: number;
    complete: boolean;
}

export interface NewCompatibilityMeasurement {
    name: string;
    notes?: string;
    duration: number;
    measurementTime: Date;
    distance: number;
    /** The positions of ALL Microphones of the FrontEnd used for the measurement as they are retrieved from the Sampler (!!!) used for the FrontEnd. */
    microphonePositions?: Point3f[];
    /** A mask indicating which of the microphones in MicrophonePositions where actually used for recording data. */
    microphoneMask?: boolean[];
    /** The indices matching the indices of the FrontEnd used for the measurement in the sequence in which they appear in the measurement's saved sound file.
Example: If this is [3 1 ...] it means that the data of the microphone at position MicrophonePositions[3] is stored first in the sound file, the data of 
microphone MicrophonePositions[1] is stored second and so on and so forth. */
    channelOrdering?: number[];
    hardwareModuleIds?: HardwareModuleReference[];
    usedWebcam?: USBDevice;
    widthInArrays: number;
    heightInArrays: number;
    /** Steps of the aquisition plan of the measurement.
Each step represents the physical location of that measurement (in [mm]!!!!) with 0,0 being the top-left of the measurement.
Z-axis is not supported yet so should always be 0. */
    steps?: Coordinate3D[];
}

export interface Point3f extends ValueType {
    X: number;
    Y: number;
    Z: number;
}

export interface HardwareModuleReference {
    ModuleId?: string;
}

export interface USBDevice {
    vendorId: number;
    productId: number;
}

/** POCO object used for serialization when posting a new measurement to the Web API */
export interface NewMeasurement {
    /** Name of the measurement */
    name: string;
    /** Optional notes for the measurements */
    notes: string;
    /** Timestamp corresponding to the start of the measurement */
    start: Date;
    /** Duration of the measurement in seconds */
    duration: number;
    /** Hint value at which approximate distance the source is located from the measurement location */
    distance?: number;
    /** Steps within the new measurement */
    parts: NewMeasurementPart[];
    /** Metadata fields for this property */
    metadata?: { [key: string]: any };
    /** The type of the special measurement */
    specialMeasurementType?: SpecialMeasurementType;
    /** The info of the special measurement in the format specific to the type */
    specialMeasurementInfo?: any;
}

/** POCO object used for serialization when posting a new measurement to the Web API This object is used for describing a step within a measurement */
export interface NewMeasurementPart {
    /** Position of the measurement device in this step */
    position: Point3;
    /** Measurement device used for this measurement step */
    device: MeasurementDeviceInfo;
    /** Type of measurement part */
    type: NewMeasurementPartType;
    /** MD5 hash of the data of this part */
    dataHash: string;
    /** Size of the data of this step */
    dataSize: number;
    /** The name of the container containing the data for this part */
    dataContainer: string;
}

export interface Point3 extends ValueType {
    X: number;
    Y: number;
    Z: number;
}

/** POCO object used to describe a measurement device when posting a new measurement to the Web API */
export interface MeasurementDeviceInfo {
    /** Set of hardware ids */
    hardwareModuleIds: string[];
    /** Set of sensor positions relative to the center of the measurement device
NOTE: The sequence in this array must match the sequence of the corresponding data file */
    sensorPositions: Point3[];
    /** Samplerate of the device, FPS for video measurement parts */
    sampleRate: number;
    /** Device specific properties of the device */
    properties?: { [key: string]: any };
}

export enum NewMeasurementPartType {
    Audio = 0,
    Video = 1,
}

export interface LicenseBundle {
    Id: string;
    LicenseHolder: LicenseHolder;
    LicenseBundleKind: LicenseBundleKind;
    OrderDate: Date;
    DeviceId?: string;
    ActivationDate?: Date;
    ExpirationDate?: Date;
}

export interface LicenseHolder {
    Id: string;
}

export interface LicenseBundleKind {
    Id: string;
    Name: string;
    Tag: string;
    LicenseKinds?: LicenseKind[];
    StartDate: Date;
    Tier: string;
    EndDate?: Date;
}

export interface ActivatedFeatureLicenseDTO {
    /** The hardware clock of the device (UNIX timestamp) */
    HardwareClock: number;
    /** The id of the device. Doesn't have a unique value across the different devices. */
    DeviceId?: string;
    /** The device type. */
    DeviceType?: string;
}

export interface NewLicenseBundleDTO {
    /** The ID of the license holder that is purchasing the bundle */
    licenseHolderId: string;
    /** The ID of the license bundle kind that is being purchased */
    licenseBundleKindId: string;
}

export interface NewLicenseBundleKindDTO {
    /** The display name of the new license bundle kind. This value can be changed later. */
    name: string;
    /** The tag of the new license bundle kind. This tag is used for all versions of the bundle, and cannot be changed later. */
    tag: string;
    /** The IDs for feature license kinds that should be included in this bundle */
    licenseKindIds: number[];
}

export interface NewFeatureLicenseKindDTO {
    /** The name of the new license kind */
    name: string;
    /** The tag of the new license kind */
    tag: string;
}

export interface WebcamConfiguration extends Webcam {
    SoundCameraModels: SoundCameraModels;
}

export interface WebcamMountConfiguration {
    SoundCameraModels: SoundCameraModels;
    Position?: Coordinate3D;
    WebcamImageOrientation: WebcamImageOrientation;
    MountableWebcams?: WebcamConfiguration[];
}

export interface MarkerConfiguration extends MarkerCollection {
    SoundCameraModels: SoundCameraModels;
}

/** A data transfer object of the hardware module credentials. */
export interface HardwareModuleCredentialsDTO {
    /** Unique identifier of the hardware module related to this credentials. */
    hardwareId: string;
    /** Password of the related hardware module. */
    password: string;
}

export interface LicenseTransactionDTO {
    /** Id of the license transaction */
    Id: number;
    /** Id of the license related to this transaction */
    LicenseId: string;
    /** Id of the selling party in this transaction */
    SellerLicenseHolderId: string;
    /** Id of the buying party in this transaction */
    BuyerLicenseHolderId: string;
    /** The date at which the transaction took place */
    TimeStamp: Date;
}

/** DTO used to assign new feature licenses to a number of listener devices */
export interface NewDeviceLicensesDTO {
    /** The IDs of the devices */
    DeviceIds?: string[];
    /** The IDs of the feature license kinds to assign to the devices */
    LicenseKindIds?: number[];
    /** The duration that the feature licenses will be valid */
    Duration?: SoramaTimeSpan;
}

/** DTO used to retrieve a feature license */
export interface LicenseRequestDTO {
    /** The identifier of the device */
    DeviceId?: string;
    /** The identifier of the feature license */
    LicenseId: string;
}

export interface TimeSignalAnalysisProperties {
    requestedMicrophone?: Point3D;
    properties?: TimeSignalAnalysisProperty[];
}

export interface TimeSignalAnalysisProperty {
    timeRange?: Range;
}

export interface Range {
    from: number;
    to: number;
}

export interface AnalysisResultOfTimeSignalAnalysisPropertyAndTimeSamplePairOf {
    properties: TimeSignalAnalysisProperty;
    data: TimeSamplePair[];
}

export interface TimeSignal extends AnalysisResultOfTimeSignalAnalysisPropertyAndTimeSamplePairOf {}

export interface TimeSamplePair {
    x: number;
    y: number;
}

export interface SpectrumSetSharedAnalysisProperties {
    requestedMicrophones?: Point3D[];
    duration: number;
}

export interface SpectrumSetAnalysisProperties extends SpectrumSetSharedAnalysisProperties {
    timeOffsets: number[];
    useIV64Method: boolean;
}

export interface AnalysisSetResultOfSpectrumSetSharedAnalysisPropertiesAndSpectrumSetSpectrumAndSpectrumSetSpectrumPropertiesAndSingleOf {
    properties: SpectrumSetSharedAnalysisProperties;
    results: SpectrumSetSpectrum[];
}

export interface FrequencySpectrumSet extends AnalysisSetResultOfSpectrumSetSharedAnalysisPropertiesAndSpectrumSetSpectrumAndSpectrumSetSpectrumPropertiesAndSingleOf {
    frequencies: number[];
}

export interface AnalysisResultOfSpectrumSetSpectrumPropertiesAndSingleOf {
    properties: SpectrumSetSpectrumProperties;
    data: number[];
}

export interface SpectrumSetSpectrum extends AnalysisResultOfSpectrumSetSpectrumPropertiesAndSingleOf {}

export interface SpectrumSetSpectrumProperties {
    timeRange: Range;
}

export interface PsychoAcousticsAnalysisProperties {
    requestedMicrophone: Point3D;
}

export interface AnalysisResultOfPsychoAcousticsAnalysisPropertiesAndPsychoAcousticsValues {
    properties: PsychoAcousticsAnalysisProperties;
    data: PsychoAcousticsValues;
}

export interface PsychoAcousticsResults extends AnalysisResultOfPsychoAcousticsAnalysisPropertiesAndPsychoAcousticsValues {}

export interface PsychoAcousticsValues extends ValueType {
    Loudness: number;
    Sharpness: number;
    Fluctuation: number;
    Tonality: number;
    Roughness: number;
}

export interface MetricPsychoAcousticsProperties extends PsychoAcousticsAnalysisProperties {
    metricName: string;
}

export interface AnalysisResultOfPsychoAcousticsAnalysisPropertiesAndTimeSamplePairOf {
    properties: PsychoAcousticsAnalysisProperties;
    data: TimeSamplePair[];
}

export interface PsychoAcousticsOverTimeResults extends AnalysisResultOfPsychoAcousticsAnalysisPropertiesAndTimeSamplePairOf {}

export interface AnalysisResultOfPsychoAcousticsAnalysisPropertiesAndFrequencySamplePairOf {
    properties: PsychoAcousticsAnalysisProperties;
    data: FrequencySamplePair[];
}

export interface PsychoAcousticsBandsResults extends AnalysisResultOfPsychoAcousticsAnalysisPropertiesAndFrequencySamplePairOf {}

export interface FrequencySamplePair extends Point2D {}

export interface CriticalBandSpectrumSet extends AnalysisSetResultOfSpectrumSetSharedAnalysisPropertiesAndSpectrumSetSpectrumAndSpectrumSetSpectrumPropertiesAndSingleOf {
    bandNr: number[];
}

export interface BeamformingProjectionSetSharedAnalysisProperties {
    requestedMicrophones?: Point3D[];
    targetPoints: Point3D[];
}

export interface BeamformingProjectionSetAnalysisProperties extends BeamformingProjectionSetSharedAnalysisProperties {
    frameProperties: BeamformingProjectionAnalysisProperty[];
}

export interface BeamformingProjectionAnalysisProperty {
    frequencies: Range[];
    timeInterval?: Range;
}

export interface AnalysisSetResultOfBeamformingProjectionSetSharedAnalysisPropertiesAndBeamformingProjectionSetProjectionAndBeamformingProjectionAnalysisPropertyAndSingleOf {
    properties: BeamformingProjectionSetSharedAnalysisProperties;
    results: BeamformingProjectionSetProjection[];
}

export interface BeamformingProjectionSet extends AnalysisSetResultOfBeamformingProjectionSetSharedAnalysisPropertiesAndBeamformingProjectionSetProjectionAndBeamformingProjectionAnalysisPropertyAndSingleOf {}

export interface AnalysisResultOfBeamformingProjectionAnalysisPropertyAndSingleOf {
    properties: BeamformingProjectionAnalysisProperty;
    data: number[];
}

export interface BeamformingProjectionSetProjection extends AnalysisResultOfBeamformingProjectionAnalysisPropertyAndSingleOf {}

export interface HolographyProjectionAnalysisProperties {
    timeInterval?: Range;
    requestedMicrophones?: Point3D[];
    properties?: HolographyProjectionAnalysisProperty[];
}

export interface HolographyProjectionHologramAnalysisProperty {
    slope: number;
    cutoff: number;
    useSNR: boolean;
    useAutomaticCutoff: boolean;
    distance: number;
    mode: HolographyProjectionMode;
}

export interface HolographyProjectionAnalysisProperty extends HolographyProjectionHologramAnalysisProperty {
    frequency: number;
}

export enum HolographyProjectionMode {
    Pressure = 0,
    Velocity = 1,
    Intensity = 2,
}

export interface AnalysisResultOfHolographyProjectionAnalysisPropertyAndComplexOf {
    properties: HolographyProjectionAnalysisProperty;
    data: Complex[];
}

export interface HolographyProjection extends AnalysisResultOfHolographyProjectionAnalysisPropertyAndComplexOf {}

export interface Complex {
    re: number;
    im: number;
}

export interface HolographyProjectionHologramAnalysisProperties {
    holograms: HologramSet;
    properties: HolographyProjectionHologramAnalysisProperty[];
}

export interface AnalysisSetResultOfHologramSetSharedAnalysisPropertiesAndHologramSetHologramAndHologramSetHologramPropertiesAndComplexOf {
    properties: HologramSetSharedAnalysisProperties;
    results: HologramSetHologram[];
}

export interface HologramSet extends AnalysisSetResultOfHologramSetSharedAnalysisPropertiesAndHologramSetHologramAndHologramSetHologramPropertiesAndComplexOf {}

export interface HologramSetSharedAnalysisProperties {
    requestedMicrophones?: Point3D[];
    timeInterval?: Range;
}

export interface AnalysisResultOfHologramSetHologramPropertiesAndComplexOf {
    properties: HologramSetHologramProperties;
    data: Complex[];
}

export interface HologramSetHologram extends AnalysisResultOfHologramSetHologramPropertiesAndComplexOf {}

export interface HologramSetHologramProperties {
    frequency: number;
}

export interface SpatialEnergyCurveSetSharedAnalysisProperties {
    timeInterval?: Range;
    requestedMicrophones?: Point3D[];
    distance: number;
    useSNR: boolean;
}

export interface SpatialEnergyCurveSetAnalysisProperties extends SpatialEnergyCurveSetSharedAnalysisProperties {
    properties: SpatialEnergyCurveAnalysisProperty[];
}

export interface SpatialEnergyCurveAnalysisProperty {
    frequency: number;
}

export interface AnalysisSetResultOfSpatialEnergyCurveSetSharedAnalysisPropertiesAndSpatialEnergyCurveSetCurveAndSpatialEnergyCurveAnalysisPropertyAndPoint2DOf {
    properties: SpatialEnergyCurveSetSharedAnalysisProperties;
    results: SpatialEnergyCurveSetCurve[];
}

export interface SpatialEnergyCurveSet extends AnalysisSetResultOfSpatialEnergyCurveSetSharedAnalysisPropertiesAndSpatialEnergyCurveSetCurveAndSpatialEnergyCurveAnalysisPropertyAndPoint2DOf {}

export interface AnalysisResultOfSpatialEnergyCurveAnalysisPropertyAndPoint2DOf {
    properties: SpatialEnergyCurveAnalysisProperty;
    data: Point2D[];
}

export interface SpatialEnergyCurveSetCurve extends AnalysisResultOfSpatialEnergyCurveAnalysisPropertyAndPoint2DOf {}

export interface SpatialEnergyCurveSetHologramAnalysisProperties extends SpatialEnergyCurveSetSharedAnalysisProperties {
    holograms: HologramSet;
}

export interface BeamformingPointAnalysisProperties {
    targetPoint: Point3D;
}

export interface TimeRangeAnalysisProperties {
    timeRange: Range;
}

export interface VideoFrame {
    data?: string;
    time: number;
    position?: Point3D;
}

// Generated using GenerateIncludedProperties in TypescriptDefinitionsGenerator.cs

export var PermissionTypeNames = {
    GlobalPermission: "GlobalPermission",
    ProjectPermission: "ProjectPermission",
    RepresentativePermission: "RepresentativePermission",
    RepresentativeGroupPermission: "RepresentativeGroupPermission",
    BusinessUnitPermission: "BusinessUnitPermission",
    ServiceProviderPermission: "ServiceProviderPermission",
};

export var PermissionPriorityChain: string[] = [
    "GlobalPermission",
    "ProjectPermission",
    "RepresentativePermission",
    "RepresentativeGroupPermission",
    "BusinessUnitPermission",
    "ServiceProviderPermission",
];

export var PermissionForTypeNames = {
    BusinessUnit: "BusinessUnit",
    RepresentativeGroup: "RepresentativeGroup",
    Representative: "Representative",
    OwnedModule: "OwnedModule",
    Permission: "Permission",
    License: "License",
    LicenseKind: "LicenseKind",
    CreditsPack: "CreditsPack",
    TokensPack: "TokensPack",
    RepresentativeGroupTemplate: "RepresentativeGroupTemplate",
};

export var PermissionForTypes: string[] = [
    "BusinessUnit",
    "RepresentativeGroup",
    "Representative",
    "OwnedModule",
    "Permission",
    "License",
    "LicenseKind",
    "CreditsPack",
    "TokensPack",
    "RepresentativeGroupTemplate",
];
